import { render, staticRenderFns } from "./ImageThumbnail.vue?vue&type=template&id=15206285&"
import script from "./ImageThumbnail.vue?vue&type=script&lang=ts&"
export * from "./ImageThumbnail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports